import { useEffect, useCallback } from 'react';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import type { Filters } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import mapDispatchToProps from './command.tsx';
import mapStateToProps from './query.tsx';
import type { Props, StateProps, DispatchProps } from './types.tsx';
import { parseFilterQueryParams, stringifyFilterQueryParams, useLocation } from './utils.tsx';

const FilterQueryParams = ({ filters, initiateFilters }: Props) => {
	const { pathname, hash, search } = useLocation();
	const { replace } = useRouterActions();

	const updateQueryParams = useCallback(
		(newFilters: Filters) => {
			const stringifiedFilters = stringifyFilterQueryParams(newFilters);
			replace({ pathname, hash, search: stringifiedFilters });
		},
		[hash, pathname, replace],
	);

	useEffect(() => {
		if (search) {
			const parsedFilters = parseFilterQueryParams(search);
			initiateFilters(parsedFilters);
		} else {
			updateQueryParams(filters);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		updateQueryParams(filters);
	}, [filters, updateQueryParams]);

	return null;
};

export default connect<StateProps, DispatchProps, {}, State>(
	mapStateToProps,
	mapDispatchToProps,
)(FilterQueryParams);
